import {
    PROVINCE_LIST_ACTION, PROVINCE_LIST_SUCCESS, PROVINCE_LIST_FAIL,
    FLIGHT_CONFIG_SUCCESS, FLIGHT_CONFIG_UPDATE, FLIGHT_CONFIG_GET, FLIGHT_CONFIG_FAIL,
    EXCHANGE_RATE_LIST_ACTION, EXCHANGE_RATE_LIST_SUCCESS, EXCHANGE_RATE_FAIL,
    EXCHANGE_RATE_UPDATE_ACTION, EXCHANGE_RATE_UPDATE_SUCCESS
} from '../constants/Types';
import { FlightConfig } from '../models/Flight';
import ExchangeRate from '../models/ExchangeRate';

const initialState = {
    isFetching: true,
    provinces: [],
    exchangeRates: [],
    detail: {
        exchangeRate: new ExchangeRate(),
    },
    flightConfig: new FlightConfig(),
};

export default (state = initialState, action) => {
    switch (action.type) {
        case PROVINCE_LIST_ACTION:
            return { ...state, isFetching: !action.withoutLoading };
        case PROVINCE_LIST_SUCCESS:
            return {
                ...state, isFetching: false, provinces: action.provinces,
            };
        case PROVINCE_LIST_FAIL:
            return { ...state, isFetching: false };

        case EXCHANGE_RATE_LIST_ACTION:
            return { ...state, isFetching: true };
        case EXCHANGE_RATE_LIST_SUCCESS:
            return {
                ...state, isFetching: false, exchangeRates: action.exchangeRates,
            };
        case EXCHANGE_RATE_UPDATE_ACTION:
            return { ...state, isFetching: true };
        case EXCHANGE_RATE_UPDATE_SUCCESS:
            return {
                ...state, isFetching: false, detail: { ...state.detail, exchangeRate: action.exchangeRate },
            };
        case EXCHANGE_RATE_FAIL:
            return { ...state, isFetching: false };

        case FLIGHT_CONFIG_GET:
            return { ...state, isFetching: true };
        case FLIGHT_CONFIG_UPDATE:
            return { ...state, isFetching: true };
        case FLIGHT_CONFIG_SUCCESS:
            return {
                ...state, isFetching: false, flightConfig: action.flightConfig,
            };
        case FLIGHT_CONFIG_FAIL:
            return { ...state, isFetching: false };
        default:
            return state;
    }
}
